import { gql } from "@apollo/client";

export const CREATE_ADVERTISER_USER = gql`
  mutation CreateAdvertiserUser($phone: String!) {
    createAdvertiserUser(phone: $phone) {
      status
      type
      message
      isNew
    }
  }
`;

export const CHECK_ADVERTISER_USER_CODE = gql`
  mutation CheckAdvertiserUserCode($phone: String!, $code: String!) {
    checkAdvertiserUserCode(phone: $phone, code: $code) {
      status
      type
      message
    }
  }
`;
